// These go into a separate file instead of HudLayer.js, because they get imported by worker code.
// Importing HudLayer as a whole would add too much clutter to the worker (e.g. LMV).
export const HUD_LAYER = Object.freeze({
    LEVELS: {id: 'LEVELS', defaultPrefs: {enabled: true}},
    SPACES: {id: 'SPACES', defaultPrefs: {enabled: true}},
    ASSETS: {id: 'ASSETS', defaultPrefs: {enabled: false}},
});
